import './DesktopAgentLoginForm.scss'

import { ErrorMessage, FieldTextV6, Spinner } from '@tallink/components-lib'
import * as PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useEffectOnce } from 'react-use'

import { agentLoggedIn, updateAgentIdFieldValue } from '../../../../../actions/actions'
import SerialTicketsClient from '../../../../../clients/SerialTicketsClient'
import { getAgent } from '../../../../../selectors/selectors'

export default function DesktopAgentLoginForm({ companyId }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { agentIdFieldValue } = useSelector(getAgent)
  const agentIdInputRef = useRef(null)
  const { register, handleSubmit, errors, setError, formState } = useForm({
    defaultValues: { agentId: agentIdFieldValue },
    mode: 'all'
  })

  useEffectOnce(() => {
    // eslint-disable-next-line no-unused-expressions
    agentIdInputRef?.current?.focus()
  })

  return (
    <>
      <form className="agent-login-form" onBlur={handleSubmit(applyAgent)} onSubmit={e => e.preventDefault()}>
        <FieldTextV6
          className="agent-input"
          disabled={formState.isSubmitting}
          inputRef={e => {
            agentIdInputRef.current = e
            register(e, {
              pattern: { value: /^\d+$/, message: t('companyCustomer.agentId.pattern') },
              required: { value: true, message: t('deliveryDetails.form.error.required') }
            })
          }}
          invalid={!!errors.agentId}
          name="agentId"
          onChange={e => dispatch(updateAgentIdFieldValue(e.target.value))}
          placeholder={t('companyCustomer.agentId')}
          size="s"
        />
        {formState.isSubmitting && <Spinner className="spinner" />}
      </form>
      {formState.touched.agentId && errors.agentId && <ErrorMessage message={errors.agentId.message} />}
    </>
  )

  async function applyAgent({ agentId }) {
    const agent = await SerialTicketsClient.getAgent(agentId, companyId)
    agent.agentId = agentId

    if (!agent || !agent.valid) {
      setError('agentId', { type: 'manual', message: t('companyCustomer.agentId.error') })
    } else {
      dispatch(agentLoggedIn(agent))
    }
  }
}

DesktopAgentLoginForm.propTypes = {
  companyId: PropTypes.string.isRequired
}
